/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_OverlineInputs */

const en_cp_cmp_overline = /** @type {(inputs: Cp_Cmp_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USE TOGETHER, NOT INSTEAD`)
};

const id_cp_cmp_overline = /** @type {(inputs: Cp_Cmp_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PAKAI BERSAMA, BUKAN PENGGANTI`)
};

/**
* | output |
* | --- |
* | "USE TOGETHER, NOT INSTEAD" |
*
* @param {Cp_Cmp_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_overline = /** @type {((inputs?: Cp_Cmp_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_overline(inputs)
	return en_cp_cmp_overline(inputs)
});